import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import CourseContent from './CourseContent';

const CourseContentContainer = (props) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isQuestionBank = pathname.includes('/public-course');
  return <CourseContent isQuestionBank={isQuestionBank} t={t} {...props} />;
};

export default CourseContentContainer;
